import { render, staticRenderFns } from "./audioimdet.vue?vue&type=template&id=9cf90086&scoped=true&"
import script from "./audioimdet.vue?vue&type=script&lang=js&"
export * from "./audioimdet.vue?vue&type=script&lang=js&"
import style0 from "./audioimdet.vue?vue&type=style&index=0&id=9cf90086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf90086",
  null
  
)

export default component.exports